import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux";

//Components
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import SourcingCommonFilter from "../../../../Components/Filter/Sourcing/SourcingCommonFilter";
import {
  addRfxNr,
  getQuotation,
  quotationListInfo,
} from "../../../../redux/feature/supplier_app/sourcingSlice";
import { SearchField } from "../../../../Components/formElements/SearchField";
import { currencyFormat, formatDateTime } from "../../../../common/Validations";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import ChatBox from "../../../../Components/ChatBox/ChatBox";
import { MessageCircle } from "lucide-react";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import { ChartBarIcon, FunnelIcon } from "@heroicons/react/24/solid";
import StatisticsContainer from "../../../../Components/Cards/StatisticsCardContainer";
import ItemService from "../../../../services/supplier_appCommonService";
import MultiColumnFilter from "../../../../Components/Filter/MultiColumnFilter";
import TableActions from "../../../smart_construction_app/Customer_V4/Common/TableActions/TableActions";

const BuyerQuotationList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "Quotation");
  let quotationData = useSelector((state) => state?.sourcing?.quotation); // User Details from Store
  let quotationTable = useSelector(
    (state) => state?.sourcing.quotation.pagination
  ); // User Details from Store

  // eslint-disable-next-line
  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [showStats, setShowStats] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (!showStats) {
      setFilteredData(quotationData?.data || []);
    }
  }, [showStats, quotationData]);
  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [filterShow, setFilterShow] = useState(false);
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const loadInitialSuuplierData = async () => {
    setData(quotationData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getQuotation(obj));
    setData(quotationData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getQuotation(obj));
    setData(quotationData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getQuotation(obj));
  };

  useEffect(() => {
    loadInitialSuuplierData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quotationData]);

  const detailedPage = (quotationNr, qtnVersion) => {
    let obj = {
      quotationNr,
      qtnVersion,
    };
    dispatch(quotationListInfo(obj));
    navigate(Constants.SOURCING_QUOTATION_DETAILS);
  };

  const detailedPageBuyer = (rfxNr) => {
    dispatch(addRfxNr(rfxNr));
    navigate(Constants.SOURCING_BUYER_RFQ_DETAILS);
  };

  const columns = [
    {
      name: "Supplier Name",
      id: "quotationSubmittedBy",
      dropDown: true,
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">
            {" "}
            {row.quotationSubmittedBy}{" "}
          </span>
        </>
      ),
      selector: (row) => row.quotationSubmittedBy,
      sortable: true,
      width: "150px",
    },
    {
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold"> {row.qtnSubmittedID} </span>
        </>
      ),
      name: "Supplier ID",
      selector: (row) => row.qtnSubmittedID,
      id: "qtnSubmittedID",
      dropDown: true,
      sortable: true,
      width: "150px",
    },
    {
      name: "Quotation Nr",
      selector: (row) => row.quotationNr || "--",
      id: "quotationNr",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.quotationNr, row.qtnVersion)}
        >
          {row.quotationNr || "-"}{" "}
        </button>
      ),
      width: "150px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },

    {
      name: "Version",
      selector: (row) => row.qtnVersion,
      sortable: true,
      width: "120px",
    },
    {
      name: "Status",
      id: "quotationStatus",
      dropDown: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.quotationStatus} />
        </>
      ),

      width: "130px",
    },
    {
      name: " Qtn Value ",
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row.qtnTotal).toFixed(2))}
        </span>
      ),
      selector: (row) => row.qtnTotal || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Currency",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">
            {" "}
            {row.qtnBidderCurrency}{" "}
          </span>
        </>
      ),
      selector: (row) => row.qtnBidderCurrency,
      sortable: true,
      width: "160px",
    },
    {
      //Add Chat Option here
      name: "Chat",
      cell: (row) => (
        <>
          <button
            onClick={() => toggleChat(row.qtnSubmittedID)}
            title={"Chat With the User"}
            className={`flex items-center gap-1 ${
              chatId === row.userId ? "text-green-600" : "text-blue-600"
            } hover:text-blue-800`}
          >
            <MessageCircle className="w-5 h-5" />
            Chat
          </button>
        </>
      ),
      width: "130px",
    },
    {
      name: "Date",
      selector: (row) => formatDateTime(row.createdAt),
      sortable: true,
      width: "190px",
    },
    {
      name: "RFQ Number",
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageBuyer(row.rfxNr)}
        >
          {row.rfxNr}{" "}
        </button>
      ),
      width: "120px",
    },
    {
      name: "RFQ Version",
      selector: (row) => row.rfxVersion || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "RFQ Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.rfxHeaderStatus} />
        </>
      ),
      width: "180px",
    },
    {
      name: "RFQ Open Date ",
      selector: (row) => formatDateTime(row.openingDateTime) || "--",
      id: "openingDateTime",
      month: true,
      sortable: true,
      width: "160px",
    },
    {
      name: "RFQ Close Date",
      id: "closingDateTime",
      month: true,
      selector: (row) => formatDateTime(row.closingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Revised Closing Date",
      selector: (row) => row.sap_rfq || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "RFQ Category",
      selector: (row) => row.rfxCategoryDesc || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Buyer Responsible",
      selector: (row) => row.buyerResponsible || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "RFQ Type",
      cell: (row) => (
        <>
          <span> {row.rfxTypeDesc} </span>
        </>
      ),
      selector: (row) => row.rfxTypeDesc || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Product Type",
      selector: (row) => row.productType || "--",
      cell: (row) => (
        <>
          <span> {row.productType} </span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Company",
      cell: (row) => (
        <>
          <span> {row.companyAddressDesc} </span>
        </>
      ),
      selector: (row) => row.companyAddressDesc || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Plant",
      cell: (row) => (
        <>
          <span> {row.plantDesc} </span>
        </>
      ),
      selector: (row) => row.plantDesc || "--",
      sortable: true,

      width: "140px",
    },
  ];

  const lineItemColInfo = [
    {
      name: "Item Number",
      cell: (row) => <span>{row.qtnItem} </span>,
      width: "150px",
    },

    {
      name: "Material",
      cell: (row) => <span>{row.materialCode} </span>,
      width: "150px",
    },
    {
      name: "Brief Description",
      cell: (row) => <span>{row.materialDescription} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "150px",
    },
    {
      name: "RFQ Quantity",
      cell: (row) => <span>{row.rfxQuantity} </span>,
      width: "150px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.rfxQuantityUnit} </span>,
      width: "150px",
    },
    {
      name: "Unit",
      cell: (row) => <span>{row.unitPrice} </span>,
      width: "150px",
    },
    {
      name: "Total",
      cell: (row) => <span>{row.lineTotal} </span>,
      width: "150px",
    },
    {
      name: "IncoTerms",
      cell: (row) => <span>{row.incoTerms} </span>,
      width: "150px",
    },
    {
      name: "IncoTerms Location",
      cell: (row) => <span>{row.incoTermsLocation} </span>,
      width: "150px",
    },
     {
      name: "Action",
      cell: (row) => (
        <TableActions
          actions={[
          {
              label: "Details",
              icon: "bi bi-info-circle",
              iconClass: "text-success",
              bg: "#e6f7ee",
              // onClick: () => showAddProduct("EDIT", row.documentNumber),
            },
            {
              label: "Edit",
              icon: "bi bi-pencil-square",
              iconClass: "text-success",
              bg: "#e6f7ee",
              // onClick: () => showAddProduct("EDIT", row.documentNumber),
            },
            {
              label: "Delete",
              icon: "bi bi-trash",
              iconClass: "text-danger",
              bg: "#fdeaea",
              // onClick: () => deleteMaterial(row),
            },
            {
              label: "More",
              icon: "bi bi-three-dots",
              bg: "#f1f3f5",
              onClick: () => console.log("More", row),
            },
          ]}
        />
      ),
      width: "180px",
    },
  ];

  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getQuotation(obj));
  };

  const columnsForFilter = columns
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));

  const [chatId, setChatId] = useState(null);
  const toggleChat = (groupId) => {
    // Toggle the same PR closes the chat
    if (chatId === groupId) {
      setChatId(null);
    } else {
      setChatId(groupId);
    }
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Quotation</h2>
                <p className="subText">Lists of Quotation and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <Col xs={12} md={12} lg={12}>
              <Row className="align-items-end justify-content-end">
                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setShowStats(!showStats)}
                    className="icon-btn"
                  >
                    <ChartBarIcon className="icon-svg" />
                  </button>
                </Col>

                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setFilterShow(!filterShow)}
                    className="icon-btn"
                  >
                    <FunnelIcon className="icon-svg" />
                  </button>
                </Col>
              </Row>
            </Col>

            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                // data={data}

                fetchFunction={ItemService.getQuotation}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            <hr />

            {showStats && (
              <div className="stats-box p-3 mb-3 position-relative">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="m-0">Statistics</h5>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "red",
                    }}
                    onClick={() => setShowStats(false)}
                  >
                    ×
                  </span>
                </div>

                <StatisticsContainer
                  api={ItemService.getQuotation}
                  keyName="rfxHeaderStatus"
                  paginatedList={quotationData?.data || []}
                  showStats={showStats}
                  onFilter={(data) => setFilteredData(data)}
                />
              </div>
            )}

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">QN</span>
                    </Col>
                    <Col xs={12} md={2} lg={2}>
                      <span className="headerTitle">Quotation List</span>
                      <span className="subHeaderTitle">
                        View of Quotation and Status
                      </span>
                    </Col>

                    {/* <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => {
                          alert("asd");
                        }}
                      >
                        <i className="bi bi-plus-lg"></i> Change Buyer
                      </button>
                    </Col> */}

                    {/* <Col xs={4} md={4} lg={4}>
                      <button
                        onClick={() => setShowStats(!showStats)}
                        className="p-1 bg-transparent border-0 cursor-pointer"
                      >
                        <ChartBarIcon className="w-7 h-7 text-blue-500" />
                      </button>
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col> */}

                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[2, 3, 4]}
                        leftOffsets={[0, 140, 240]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          // data={data}
                          data={filteredData}
                          progressPending={quotationData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={quotationTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}
    </main>
  );
};

export default BuyerQuotationList;
